/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("CanvasArcParametersVMBehavior", ["BehaviorBase"], function (context, cls) {
  /**
   * Behavior controlling the widget's Menu
   * @class CanvasArcParametersVMBehavior
   * @memberOf classes
   * @extends classes.BehaviorBase
   */
  cls.CanvasArcParametersVMBehavior = context.oo.Singleton(cls.BehaviorBase, function ($super) {
    return /** @lends classes.CanvasArcParametersVMBehavior.prototype */ {
      __name: "CanvasArcParametersVMBehavior",

      watchedAttributes: {
        anchor: ["startX", "startY", "diameter", "startDegrees", "extentDegrees"]
      },
      /**
       * @inheritDoc
       */
      _apply: function (controller, data) {
        const node = controller.getAnchorNode();
        const startX = node.attribute("startX");
        const startY = node.attribute("startY");
        const diameter = node.attribute("diameter");
        const startDegrees = node.attribute("startDegrees");
        const extentDegrees = node.attribute("extentDegrees");

        controller.getWidget().setParameters(startX, startY, diameter, startDegrees, extentDegrees);
      }
    };
  });
});
